export default {
  row1 :[
  {
    column: "column1",
    columnWidth:"48%",
    rows: {
      row1: [
        {
          name: "areNo",
          label: "ARE Number",
          component: "text-field",

        },
      ],
      row2: [
        {
          name: "areDate",
          label: "ARE Date",
          component: "dateselector",
          width:"100%"

        },
    
      ],
      row3: [
        {
          name: "areCommissionerate",
          label: "Commissionerate",
          component: "text-field",
        },
      ],
    },
  },
  {
    column: "column2",
    columnWidth:"48%",
    rows: {
      row1: [
        {
          name: "areDivision",
          label: "Division",
          component: "text-field",
        },
      ],
      row2: [
        {
          name: "areRange",
          label: "Range",
          component: "text-field",
        },
      ],
      row3: [
        {
          name: "areRemark",
          label: "Remark",
          component: "text-field",
        },
      ],
    },
  },
]
};
